import React, { Component } from 'react'
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import moment from 'moment';
import Datetime from 'react-datetime';

import style from "./DXFormStyles";
export default class DXFormInputDate extends Component {

  constructor(props) {
    super(props);
    const {
      pid,
      question,
      setFormValueState,
    } = this.props;
    const id = `${pid}.${question.id}`;
    const { defaultValue } = question;

    const readonly = setFormValueState === null;

    if (!readonly && defaultValue && defaultValue === 'today') {
      const dateString = moment().format('YYYY-MM-DD');
      setFormValueState(id, dateString);
      setFormValueState(id + "State", "success");
    }

    this.state = {
      id,
      question,
      defaultValue
    }


  }

  render() {
    const {
      id,
      question,
      defaultValue
    } = this.state;

    const {
      setFormValueState,
    } = this.props;

    return <GridContainer key={id} justify='center'>
      <GridItem xs={12} sm={2}>
        <h4 style={style.infoText}>
          {question.title}
        </h4>
      </GridItem>
      <GridItem xs={12} sm={10}>
        <Datetime
          dateFormat="YYYY-MM-DD"
          defaultValue={defaultValue && defaultValue === 'today' ? moment().format('YYYY-MM-DD') : ''}
          timeFormat={false}
          onChange={d => {
            console.log('date = ', d.format('YYYY-MM-DD'));
            const dateString = d.format('YYYY-MM-DD');
            setFormValueState(id, dateString);
            setFormValueState(id + "State", "success");
          }}
          inputProps={{
            placeholder: question.title,
            onInput: event => this.props.onChange(event, id, { type: "date" }),
            readOnly: setFormValueState === null
          }}
        />
      </GridItem>
    </GridContainer>
  }
}
